﻿import {JSX, memo} from "react";
import {TabPanelProps} from "./TabPanelProps";

function TabPanel(props: TabPanelProps): JSX.Element {
	return <>{props.children}</>;
}

const MemoizedTabPanel: React.FC<TabPanelProps> = memo(TabPanel);
export default MemoizedTabPanel;
